import { render, staticRenderFns } from "./addTagUtil.vue?vue&type=template&id=3605e330&scoped=true"
import script from "./addTagUtil.vue?vue&type=script&lang=js"
export * from "./addTagUtil.vue?vue&type=script&lang=js"
import style0 from "./addTagUtil.vue?vue&type=style&index=0&id=3605e330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3605e330",
  null
  
)

export default component.exports